import { render, staticRenderFns } from "./orderWxOtherShenpi.vue?vue&type=template&id=4857595b&scoped=true"
import script from "./orderWxOtherShenpi.vue?vue&type=script&lang=js"
export * from "./orderWxOtherShenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxOtherShenpi.vue?vue&type=style&index=0&id=4857595b&prod&scoped=true&lang=css"
import style1 from "./orderWxOtherShenpi.vue?vue&type=style&index=1&id=4857595b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857595b",
  null
  
)

export default component.exports